import { GLAvatar, GLDetailsHeader, GLDetailsHeaderRating, GLDetailsHeaderTitle, GlobalViewDetailsContainer, SelectedPinAction } from './GlobalView.styled'
import Avatar from '../../assets/images/profileAvatar.png'
import { getMachineCategoryIcon } from 'pages/Machinery/machineCategoryIcons'

export const getInitials = (name?: string) => {
    if (!name) return '?'
    const parts = name.trim().split(/\s+/)
    return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase()
}
import { OtherText, TitleText } from 'styling/Typography'
import { RatingIcon } from 'assets/icons/RatingIcon'
import { ISelectedPin } from 'types/global-view.interface'
import { XIcon } from 'assets/icons/XIcon'
import { ShrinkIcon } from 'assets/icons/ShrinkIcon'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { handleMachineStatus } from 'utils/helpers'
import { SetStateAction, useRef } from 'react'
import { WorkerDetails } from './Details/DetailsWorker'
import { MachineDetails } from './Details/MachineDetails'
import { MachineTrips } from './Details/MachineTrips'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { IStatusPill } from 'types/ui/statusPill.interface'
import { tokens } from 'styling/tokens'

const machineStatusTone: { [key: number]: IStatusPill['status'] } = {
    1: 'success',
    2: 'accent',
    3: 'danger',
    4: 'warning',
    5: 'neutral',
}

export const GlobalViewDetails = ({ map, openedPin, handleClosePin, handleUnselectPin, setSelectedPins }: { setSelectedPins: React.Dispatch<SetStateAction<ISelectedPin[]>>, map: any, openedPin: ISelectedPin, handleClosePin: (pin: ISelectedPin) => void, handleUnselectPin: (pin: ISelectedPin, unselect?: boolean) => void }) => {
    const { workerInfo, machineInfo } = useSelector((state: RootState) => state.globalView)
    const historyRef = useRef(null)

    const unselectPin = (openedPin: ISelectedPin) => {
        if (historyRef.current) {
            historyRef.current.setMap(null)
            historyRef.current = null
        }
        handleUnselectPin(openedPin, true)
    }

    const handleCloseTrips = () => {
        setSelectedPins(prev => prev.map(p => ({ ...p, showTrips: false })))
    }
    return <GlobalViewDetailsContainer closed={!openedPin?.id} >
        <SelectedPinAction style={{ top: '1.3rem' }} onClick={() => unselectPin(openedPin)} ><XIcon /></SelectedPinAction>
        <SelectedPinAction style={{ top: '3.5rem' }} onClick={() => handleClosePin(openedPin)}> <ShrinkIcon /> </SelectedPinAction>
        <GLDetailsHeader>
            <GLDetailsHeaderTitle>
                {openedPin?.type === 'employee' ? (
                    <GLAvatar>
                        {workerInfo?.profileImageUrl ? (
                            <img src={workerInfo.profileImageUrl} alt='' onError={({ currentTarget }) => { currentTarget.onerror = null; currentTarget.src = Avatar }} />
                        ) : getInitials(openedPin?.name)}
                    </GLAvatar>
                ) : (
                    <GLAvatar $machine>
                        {getMachineCategoryIcon(machineInfo?.category?.iconName, tokens.accent.base, 22)}
                    </GLAvatar>
                )}
                <div className="text">
                    <TitleText color={tokens.text.primary} weight="600" >{openedPin?.name}</TitleText>
                    <OtherText color={tokens.text.secondary} >{openedPin?.type == 'employee' ? workerInfo?.role.name : (machineInfo?.user ? (machineInfo?.user?.firstName + ' ' + machineInfo?.user?.lastName) : '/')}</OtherText>
                    {openedPin?.type == 'machine' && <OtherText color={tokens.text.secondary} >Status: <StatusPill status={machineStatusTone[machineInfo?.status] ?? 'neutral'}>{handleMachineStatus(machineInfo?.status)}</StatusPill></OtherText>}
                </div>
            </GLDetailsHeaderTitle>
            {openedPin?.type === 'employee' && (
                <GLDetailsHeaderRating>
                    <RatingIcon />
                    <OtherText color={tokens.text.secondary} >{workerInfo?.rating?.qualityRating}</OtherText>
                </GLDetailsHeaderRating>
            )}
        </GLDetailsHeader>
        {openedPin?.showTrips ? <MachineTrips closeTrips={handleCloseTrips} map={map} /> : openedPin?.type == 'employee' ? <WorkerDetails /> : <MachineDetails openedPin={openedPin} map={map} setSelectedPins={setSelectedPins} />}

    </GlobalViewDetailsContainer>
}